import React from 'react';
import { Check, X } from 'lucide-react';

const RULES = [
  { label: '8 caractères minimum', test: pw => pw.length >= 8 },
  { label: 'Une majuscule', test: pw => /[A-Z]/.test(pw) },
  { label: 'Un chiffre', test: pw => /[0-9]/.test(pw) },
  { label: 'Un caractère spécial', test: pw => /[^A-Za-z0-9]/.test(pw) },
];

export function checkPasswordStrength(pw) {
  const passed = RULES.filter(r => r.test(pw)).length;
  if (passed <= 1) return { level: 0, label: 'Très faible', color: '#EF4444' };
  if (passed === 2) return { level: 1, label: 'Faible', color: '#F97316' };
  if (passed === 3) return { level: 2, label: 'Correct', color: '#EAB308' };
  return { level: 3, label: 'Fort', color: '#22C55E' };
}

export default function PasswordStrengthIndicator({ password }) {
  if (!password) return null;
  const strength = checkPasswordStrength(password);

  return (
    <div className="mt-2 space-y-1.5">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map(i => (
          <div key={i} className="h-1 flex-1 rounded-full transition-all duration-300"
            style={{ background: i <= strength.level ? strength.color : '#E5E7EB' }} />
        ))}
      </div>
      <p className="text-xs font-medium" style={{ color: strength.color }}>{strength.label}</p>
      <ul className="space-y-0.5">
        {RULES.map(r => {
          const ok = r.test(password);
          return (
            <li key={r.label} className="flex items-center gap-1.5 text-xs"
              style={{ color: ok ? '#16A34A' : '#9CA3AF' }}>
              {ok ? <Check size={11} /> : <X size={11} />}
              {r.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
